import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import debounce from 'lodash.debounce';
import { Controller, useFormContext } from 'react-hook-form';
import useFetchBrands from '../../../../hooks/brands/useFetchBrands';
import { setBrandsSearchAction } from '../../../../redux/actions/brandsActions';
import { setModelBrandAction } from '../../../../redux/actions/modelsActions';
import SearchableSelect from './../SearchableSelect';

const BrandSelect = ({ disabled }) => {
  const {
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const { brands } = useFetchBrands({ unpaged: true });
  const dispatch = useDispatch();
  const isMobileView = useSelector((state) => state.screen.isMobileView);

  const selectOptions = brands.map((brand) => {
    return {
      label: brand.name,
      value: brand,
    };
  });

  const handleInputChange = (newValue) => {
    debounced(newValue);
  };

  const debounced = debounce((newValue) => {
    dispatch(setBrandsSearchAction(newValue));
  }, 300);

  const handleOnChange = async (onChange, selectedValue) => {
    onChange(selectedValue);
    await dispatch(setModelBrandAction(selectedValue));
    setValue('model', undefined);
    clearErrors('model');
  };

  return (
    <div>
      <label className="input-label">Марка</label>
      <Controller
        name="brand"
        rules={{ required: "Це поле є обов'язковим" }}
        control={control}
        render={({ field: { onChange, value } }) => (
          <SearchableSelect
            disabled={disabled}
            value={value ? { label: value.name, value: value } : null}
            options={selectOptions}
            isMobileView={isMobileView}
            placeholder={'Виберіть марку'}
            handleInputChange={handleInputChange}
            onChange={(selectOptions) => handleOnChange(onChange, selectOptions)}
          />
        )}
      />
      {errors['brand'] && <span className="text-xs text-contrast1 mt-1">{errors['brand'].message}</span>}
    </div>
  );
};
export default BrandSelect;
